import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowRightIcon, CheckCircleIcon } from '@heroicons/react/24/outline';
import { formatDisplayDateTime } from '../../../utils/dateFormatting';
import Placeholder from '../../../ui/atoms/Placeholder';
import DashboardWidgetShell from './DashboardWidgetShell';
import { widgetFooterLinkClass } from './widgetAnalyticsUi';
import PriorityPill from './PriorityPill';

const AttentionWidget = ({
  attentionSessions = [],
  actionRequiredCount = 0,
  onNavigate
}) => {
  const { t, i18n } = useTranslation();

  const subtitle = actionRequiredCount > 0
    ? t('dashboard.agent.attentionCount', { count: actionRequiredCount })
    : t('dashboard.agent.attentionSubtitle');

  return (
    <DashboardWidgetShell
      variant="chart"
      title={t('dashboard.agent.attentionTitle')}
      subtitle={subtitle}
      footer={
        <button
          type="button"
          onClick={() => onNavigate('/agent/assistants')}
          className={widgetFooterLinkClass}
        >
          {t('dashboard.agent.viewInbox')}
          <ArrowRightIcon className="ml-1 h-3.5 w-3.5" />
        </button>
      }
    >
      {attentionSessions.length > 0 ? (
        <ul className="max-h-64 space-y-1 overflow-y-auto">
          {attentionSessions.map((session) => (
            <li key={session.id}>
              <button
                type="button"
                onClick={() => onNavigate(`/agent/chat/${session.id}`)}
                className="w-full rounded-lg px-2 py-2.5 text-left transition-colors hover:bg-gray-50"
              >
                <div className="flex items-start gap-2">
                  <PriorityPill priority={session.priority} />
                  <div className="min-w-0 flex-1">
                    <p className="text-sm text-gray-900 line-clamp-2 leading-snug">
                      {session.title}
                    </p>
                    <p className="text-[11px] text-gray-500 mt-1">
                      {formatDisplayDateTime(session.dateCreated, i18n.language)}
                    </p>
                  </div>
                </div>
              </button>
            </li>
          ))}
        </ul>
      ) : (
        <Placeholder
          empty
          size="s"
          icon={CheckCircleIcon}
          message={t('dashboard.agent.attentionEmpty')}
        />
      )}
    </DashboardWidgetShell>
  );
};

export default AttentionWidget;
